import { render, staticRenderFns } from "./user_events.vue?vue&type=template&id=0a0114b1&scoped=true&"
import script from "./user_events.vue?vue&type=script&lang=js&"
export * from "./user_events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0114b1",
  null
  
)

export default component.exports